import { Component } from '@angular/core';
import { INSPECTIONS_CARDS } from '../../data/inspections-cards.data';
import { SectionCardInterface } from '../../data/interfaces/SectionCardInterface';
import { InspectionsCard } from '../inspections-card/inspections-card';

@Component({
  selector: 'app-inspections',
  imports: [InspectionsCard],
  templateUrl: './inspections.html',
  styleUrl: './inspections.scss',
})
export class Inspections {

  cards: Array<SectionCardInterface> = INSPECTIONS_CARDS

}
